<template>
  <div v-if="jwtAccessValid()" class="container ml-1">
    <header>
      <b-row>
      <b-col sm="4">
        <h2 class="align-middle">Отчет по выручке</h2>
      </b-col>
      <b-col sm="2">
        <b-button 
        variant="success"
        @click="fetchReportData()">
          Сформировать
        </b-button>
      </b-col>
      </b-row>
      
    </header>
    <div class="container" style="text-align:left">
    <b-row align-v="center" class="mb-2">
      <b-col sm="1">
        Период
      </b-col>
      <b-col sm="3">
        <b-form-input type="date" v-model="reportDateFrom"></b-form-input>
      </b-col>
      <b-col sm="3">
        <b-form-input type="date" v-model="reportDateTo"></b-form-input>
      </b-col>
    </b-row>
    
    
    </div>
    <b-overlay
    id="overlay-background"
    :show="false"
    variant="white"
    opacity="0.50"
    blur="2px"
    class="d-inline-block"
    style="float:left">
    <template v-slot:overlay>
      <div></div>
    </template>
    <div >
      <b-table class="report-table list" 
      striped 
      hover
      bordered
      :items="reportData" 
      :fields="reportFields"
      sort-by="date"
      sticky-header1
      responsive="sm"
      :small="true">
        <template v-slot:thead-top>
          <b-tr v-for="level in levelRange" :key=level>
            <th-wrap v-for="field in colspanFields(level)" 
            :key="field.key" 
            :field="field"
            :level="level">
            </th-wrap>
          </b-tr>
          
        </template>
        <template slot="custom-foot" slot-scope>
          <tr>
            <td><span class='total'>Итого</span></td>
            <td v-for="field in reportFields.slice(1)" :key="field.key">
              <span v-if="(('total' in field) && field.total)" class='total'>{{ colSum(field.key) }}</span>
              <span v-else class='total'></span>
            </td>
          </tr>
          <tr>
            <td><span class='total'>Общий итог</span></td>
            <td-total-wrap v-for="field in colspanFields(0).slice(1)" :key="field.key"
            :field="field"
            :reportData="reportData"
            :reportFields="reportFields"
            >
            </td-total-wrap>
          </tr>
        </template>
      </b-table>
    </div>
    </b-overlay>

  </div>
</template>

<script>
import { HTTP } from '@/script/http-common'
import thWrap from '@/components/thWrap.vue'
import tdTotalWrap from '@/components/tdTotalWrap.vue'
import ReportMixin from '@/components/ReportMixin.vue'

export default {
  name: 'ReportRevenue2',
  components: {
    thWrap,
    tdTotalWrap,
  },

  mixins: [ReportMixin],

  props: {
  },

  data () {
    return {
      status: {
        sortBy: 'date',
        sortAsc: false,
      },
      reportData: [],
      reportResponse: [],
      reportDateFrom: null,
      reportDateTo: null,
      reportShop: '_ALL_',
      shopList: [],
      reportFields: [
        {
          key: 'date',
          label: 'Дата',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.dateFormatter(value)},
          stickyColumn: true,
          isRowHeader: true,
        },
      ],
      reportFieldsDEF: [
        {
          key: 'date',
          label: 'Дата',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.dateFormatter(value)},
          stickyColumn: true,
          isRowHeader: true,
        },
        {
          key: 'amountDayShift',
          label: 'День',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          colspanNum: 2,
          colspanLabel: 'Выручка',
          total: true,
        },
        {
          key: 'amountNightShift',
          label: 'Ночь',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          total: true,
        },
        {
          key: 'expenditureSalaryDayShift',
          label: 'День',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          colspanNum: 2,
          colspanLabel: 'Расходы ЗП',
          total: true,
        },
        {
          key: 'expenditureSalaryNightShift',
          label: 'Ночь',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          total: true,
        },
        {
          key: 'expenditureBonusDayShift',
          label: 'День',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          colspanNum: 2,
          colspanLabel: 'Расходы ЗП и премия',
          total: true,
        },
        {
          key: 'expenditureBonusNightShift',
          label: 'Ночь',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          total: true,
        },
        {
          key: 'expenditureSalaryBonusDayShift',
          label: 'День',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          colspanNum: 2,
          colspanLabel: 'Расходы ЗП и ежедн премия',
          total: true,
        },
        {
          key: 'expenditureSalaryBonusNightShift',
          label: 'Ночь',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          total: true,
        },
        {
          key: 'expenditureMiscDayShift',
          label: 'День',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          colspanNum: 2,
          colspanLabel: 'Расходы прочие',
          total: true,
        },
        {
          key: 'expenditureMiscNightShift',
          label: 'Ночь',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          total: true,
        },
        {
          key: 'cashDayShift',
          label: 'День',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          colspanNum: 2,
          colspanLabel: 'Размен на конец дня',
          total: true,
        },
        {
          key: 'cashNightShift',
          label: 'Ночь',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          total: true,
        },
        {
          key: 'safeDayShift',
          label: 'День',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          colspanNum: 2,
          colspanLabel: 'Сейф на конец дня',
          total: true,
        },
        {
          key: 'safeNightShift',
          label: 'Ночь',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          total: true,
        },
        {
          key: 'writeoff',
          label: 'Списание',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          total: true,
        },
        {
          key: 'revaluation',
          label: 'Переоценка',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          total: true,
        },
        {
          key: 'deliveryDayShift',
          label: 'День',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          colspanNum: 2,
          colspanLabel: 'Доставка',
          total: true,
        },
        {
          key: 'deliveryNightShift',
          label: 'Ночь',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          total: true,
        },
        {
          key: 'moveDayShift',
          label: 'День',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          colspanNum: 2,
          colspanLabel: 'Перемещение',
          total: true,
        },
        {
          key: 'moveNightShift',
          label: 'Ночь',
          sortable: true,
          type: 'text', width: '100px',
          formatterSort: false,
          formatter: value => { return this.numFormatter(value)},
          total: true,
        },
      ],
    }       
  },
  
  methods: {
    buildReportData(){
      const vm = this
      vm.reportFields = vm.reportFields.slice(0,1)
      vm.reportData = []
      vm.reportResponse.forEach((row) => {
        let dataIndex = vm.reportData.findIndex(data => data.date == row.date)
        let shopID = vm.shopList.find(shop => shop.label == row.shop).id
        if (dataIndex >= 0) {
          vm.reportData[dataIndex][`amountDayShift_${shopID}`] = row.amountDayShift
          vm.reportData[dataIndex][`amountNightShift_${shopID}`] = row.amountNightShift
        } else {
          let newData = {date: row.date}
          newData[`amountDayShift_${shopID}`] = row.amountDayShift
          newData[`amountNightShift_${shopID}`] = row.amountNightShift
          // newData['_cellVariants'] = {}
          vm.reportData.push(newData)
        }

        let fieldIndex = vm.reportFields.findIndex(field => field.key == `amountDayShift_${shopID}`)
        if (fieldIndex < 0) {
          vm.reportFields.push({
            key: `amountDayShift_${shopID}`,
            label: 'День',
            sortable: true,
            formatterSort: false,
            formatter: value => { return vm.numFormatter(value)},
            colspanNum: [2],
            colspanLabel: [row.shop],
            total: true,
          })
        }

        fieldIndex = vm.reportFields.findIndex(field => field.key == `amountNightShift_${shopID}`)
        if (fieldIndex < 0) {
          vm.reportFields.push({
            key: `amountNightShift_${shopID}`,
            label: 'Ночь',
            sortable: true,
            formatterSort: false,
            formatter: value => { return vm.numFormatter(value)},
            total: true,
            tdClass: 'night-shift',
          })
        }

      })
      
      vm.reportData.forEach((row) => {
        console.log('Row keys', Object.keys(row))
        row['totalRow'] = Object.keys(row).reduce((a, b) => {
            let rowB = b != 'date' ? row[b] : 0
            return Number(a) + Number(rowB || 0)
          }, 0)
      })

      vm.reportFields.push({
            key: 'totalRow',
            label: 'Итого',
            sortable: true,
            formatterSort: false,
            formatter: value => { return vm.numFormatter(value)},
            total: true,
            isRowHeader: true,
      })


    },

    async fetchReportData() {
      const vm = this
      try {
        let response = await HTTP(vm.jwtAccess()).get(`report-finance/?dateFrom=${vm.reportDateFrom}&dateTo=${vm.reportDateTo}&shop=${vm.reportShop}`)
        if (response.status >= 200 && response.status < 300) {
          vm.reportResponse = response.data
          await vm.fetchShopList()
          vm.buildReportData()
        }
      } catch(error) {
        console.log(error)
      }
    },
    
    async fetchShopList() {
      const vm = this
      try {
        let response = await HTTP(vm.jwtAccess()).get(`shop/`)
        if (response.status >= 200 && response.status < 300) {
          vm.shopList = response.data
        }
      } catch(error) {
        console.log(error)
      }
    },

  },

  mounted() {
    const vm = this
    vm.reportDateFrom = (new Date).toISOString().split("T")[0].slice(0, 8) + "01"
    vm.reportDateTo = (new Date).toISOString().split("T")[0]
    vm.fetchShopList()
    vm.fetchReportData()
  },
  
}
</script>

<style>
header {
  text-align: left;
}

.night-shift {
  background: #e9ecef99;
}

.total {
   font-weight: bold;
}

.report-table {
  font-size: 0.9rem
}

th {
  background: white;
  position: sticky;
  top: 0; /* Don't forget this, required for the stickiness */
}

</style>